export default function Spacer () { return <tr key='spacer' className='spacer'><td>&nbsp;</td></tr> }
